export enum TARGET_SEARCH {
  NAME_COMPANY = `nom_entreprise`,
  SIREN = `siren`,
  SIRET = `siret`,
  REPRESENTATIVE = `representant`,
  FULL_NAME = `nom_complet`,
  DENOMINATION = `denomination`,
}
